module.exports = "<iframe style=\"border: 0\"  [src]=\"url\" width=\"100%\" height=\"100%\" >\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/external-billing/external-denials-audits/external-denials-audits.component.html
// module id = 2443
// module chunks = 66